import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogActions, Button, DialogContentText } from '@mui/material';

import OperationForm from './OperationForm';

// second keepalive time is configured in 10 minute steps (same encoding as the
// scheduler configuration). 143 * 10 min = 23:50, the latest allowed wake time.
const MAX_SECOND_KEEPALIVE_TIME = 143;
const MAX_RANDOM_BACKOFF_MINUTES = 30;

function toPayload(v) {
  return {
    second_keepalive_time_local: Number(v.second_keepalive_time_local),
    random_backoff_keepalive_minutes: Number(v.random_backoff_keepalive_minutes),
  };
}

export default function ConfSetSecondKeepAlive(props, context) {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(null);

  const validate = (payload) => {
    if (payload.second_keepalive_time_local > MAX_SECOND_KEEPALIVE_TIME) {
      return context.t('second_keepalive_time_invalid');
    }
    if (payload.random_backoff_keepalive_minutes > MAX_RANDOM_BACKOFF_MINUTES) {
      return context.t('second_keepalive_backoff_invalid');
    }
    if (
      payload.second_keepalive_time_local * 10 <=
      payload.random_backoff_keepalive_minutes
    ) {
      return context.t('second_keepalive_backoff_exceeds_time');
    }
    return null;
  };

  const handleFormSubmit = (data) => {
    const payload = toPayload(data);
    const error = validate(payload);
    if (error) {
      props.notify(error, 'error');
      return;
    }
    setValues(payload);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setValues(null);
  };

  const handleConfirm = () => {
    if (values) {
      props.updateConfig(values);
    }
    handleClose();
  };

  return (
    <>
      <OperationForm
        stacked
        notify={props.notify}
        enable={props.enable}
        fields={props.fields}
        onSubmit={handleFormSubmit}
      />

      <Dialog open={open} onClose={handleClose} maxWidth="sm">
        <DialogContent>
          <DialogContentText
            style={{ fontSize: 'large', color: 'black', textAlign: 'center' }}
          >
            {context.t(
              'you_are_about_to_take_a_significant_action_on_num_devices',
              { num: props.countSelected }
            )}
            <br />
            <span
              style={{ fontSize: 'medium', color: '#606060', display: 'block' }}
            >
              {context.t('confirm_updating_second_keepalive_config')}
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {context.t('cancel')}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {context.t('continue')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ConfSetSecondKeepAlive.propTypes = {
  enable: PropTypes.bool,
  countSelected: PropTypes.number,
  fields: PropTypes.array,
  notify: PropTypes.func.isRequired,
  updateConfig: PropTypes.func.isRequired,
};

ConfSetSecondKeepAlive.defaultProps = {
  enable: false,
  countSelected: 0,
  fields: [],
};

ConfSetSecondKeepAlive.contextTypes = {
  t: PropTypes.func.isRequired,
};
